import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQuery';

export const historyApi = createApi({
    reducerPath: 'history',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['history', 'downloadHistory', 'documentHistoryById'],
    endpoints: (builder) => ({
        getRequestHistory: builder.query({
            query: () => ({
                url: 'historial/consultas'
            }),
            transformResponse: (response: { data: any }) => response?.data
        }),
        getDownloadHistory: builder.query({
            query: () => ({
                url: 'historial/descargas'
            }),
            providesTags: ['downloadHistory'],
            transformResponse: (response: { data: any }) =>
                response?.data?.map((item: any, index: number) => ({ ...item, id: index + 1 }))
        }),
        getAttachmentHistory: builder.query({
            query: () => ({
                url: 'historial/adjuntos'
            }),
            transformResponse: (response: { data: any }) =>
                response?.data?.map((item: any, index: number) => ({ ...item, id: index + 1 }))
        }),
        downloadDocById: builder.mutation({
            query: (data: { idDocumento: string; tipoDocumento: string }) => ({
                url: 'historial/descargas',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (_, error) =>
                error ? [] : ['documentHistoryById', 'downloadHistory'],
            transformResponse: (response: { data: any }) =>
                response?.data?.map((item: any, index: number) => ({ ...item, id: index + 1 }))
        }),
        documentHistoryById: builder.query({
            query: ({ docId, tab }: any) => ({
                url: `historial/documento/${tab}/${docId}`,

                transformResponse: (response: { data: { data: any } }) => response?.data?.data
            }),
            providesTags: ['documentHistoryById']
        })
    })
});
export const {
    useDocumentHistoryByIdQuery,
    useDownloadDocByIdMutation,
    useGetRequestHistoryQuery,
    useGetAttachmentHistoryQuery,
    useGetDownloadHistoryQuery
} = historyApi;
